import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TLocalesKeys as K } from '../../../../../types';
import { hasContent } from '../../../../../util/guards';
import { Button } from '../../../../common/components/Button';
import { FullscreenDialog } from '../../../../common/components/FullscreenDialog';
import { headerActions } from '../../../../common/reducers/header';
import { selectAnnouncement } from '../../../../common/selectors/header';
import { renderModel } from '../../../../util/renderModel';
import { Banner } from '../Banner';
import { AnnouncementCtaButton } from './AnnouncementCtaButton';
import s from './styles.scss';

const isMobile = renderModel.isMobile();

type AnnouncementBannerProps = {
  dataHook?: string;
};

export const AnnouncementBanner: FC<AnnouncementBannerProps> = memo(({ dataHook }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const announcement = useSelector(selectAnnouncement);
  if (!announcement) {
    return null;
  }
  const renderCtaButton = hasContent(announcement.label) && hasContent(announcement.url) && (
    <AnnouncementCtaButton
      label={announcement.label}
      url={announcement.url}
      className={isMobile ? s.linkMobile : s.link}
    />
  );
  if (isMobile) {
    const onClose = () => {
      dispatch(headerActions.hideAnnouncement());
    };

    return (
      <FullscreenDialog close={onClose}>
        <div className={s.title}>{t<K>('announcement_mobile_title')}</div>
        <div className={s.text}>{announcement.errorMsg}</div>
        {renderCtaButton}
        <Button primary onClick={onClose}>
          {t<K>('announcement_mobile_contact_btn')}
        </Button>
      </FullscreenDialog>
    );
  }
  return (
    <Banner theme="standard" dataHook={dataHook}>
      <div className={s.extraWidth}>{announcement.errorMsg}</div>
      {renderCtaButton}
    </Banner>
  );
});

